import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, class_type, string_type, bool_type, union_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Account_UserInfo_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Remote$1, Remote$1_$reflection, GlobalMsg_$reflection } from "../../../Bfs.Web.Portale/Types.fs.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Notifications"];
    }
}

export function Page_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Notifications.Types.Page", [], Page, () => [[]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PostImPortalChanged", "PreisInfosChanged", "BelegeingangChanged", "BelegpruefungAbgeschlossenChanged", "AuszahlungGetaetigtChanged", "TicketAntwortChanged", "SubmitNotifications", "NotificationsRequestDone", "LoadUserInfo", "UserInfoLoaded", "LoadPushSubscription", "LoadPushSubscriptionCompleted", "ValidatePushEndpointCompleted", "ChangePushSubscription", "ChangePushSubscriptionCompleted", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Notifications.Types.Msg", [], Msg, () => [[["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [string_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", string_type]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Account_UserInfo_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Account_UserInfo_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Bfs.Web.Kundenportal.PWA.NotificationBindings.PushSubscription"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Bfs.Web.Kundenportal.PWA.NotificationBindings.PushSubscription")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", bool_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class PushState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AppUndecided", "AppDenied", "Disabled", "Enabled"];
    }
}

export function PushState_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Notifications.Types.PushState", [], PushState, () => [[], [], [], []]);
}

export class Model extends Record {
    constructor(UserInfo, Email, Name, PostImPortal, PreisInfos, Belegeingang, BelegpruefungAbgeschlossen, AuszahlungGetaetigt, TicketAntwort, Sending, PushState, SendingPushState) {
        super();
        this.UserInfo = UserInfo;
        this.Email = Email;
        this.Name = Name;
        this.PostImPortal = PostImPortal;
        this.PreisInfos = PreisInfos;
        this.Belegeingang = Belegeingang;
        this.BelegpruefungAbgeschlossen = BelegpruefungAbgeschlossen;
        this.AuszahlungGetaetigt = AuszahlungGetaetigt;
        this.TicketAntwort = TicketAntwort;
        this.Sending = Sending;
        this.PushState = PushState;
        this.SendingPushState = SendingPushState;
    }
}

export function Model_$reflection() {
    return record_type("Bfs.Web.Kundenportal.WebParts.Notifications.Types.Model", [], Model, () => [["UserInfo", Remote$1_$reflection(Account_UserInfo_$reflection())], ["Email", string_type], ["Name", string_type], ["PostImPortal", bool_type], ["PreisInfos", bool_type], ["Belegeingang", bool_type], ["BelegpruefungAbgeschlossen", bool_type], ["AuszahlungGetaetigt", bool_type], ["TicketAntwort", bool_type], ["Sending", bool_type], ["PushState", Remote$1_$reflection(PushState_$reflection())], ["SendingPushState", bool_type]]);
}

export function Model_Init(email, name) {
    return new Model(new Remote$1(1, []), email, name, false, false, false, false, false, false, true, new Remote$1(1, []), false);
}

//# sourceMappingURL=Types.fs.js.map
